import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/leftArrowIcon.svg'
import _imports_1 from '@/assets/rightArrowIcon.svg'
import _imports_2 from '@/assets/settings.svg'
import _imports_3 from '../assets/training.svg'


const _hoisted_1 = { id: "body-container" }
const _hoisted_2 = { class: "SessionPopup" }
const _hoisted_3 = { class: "flex navchild items-center hover:text-black py-1" }
const _hoisted_4 = { class: "bottomUl mb-16" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "mt-2" }
const _hoisted_7 = {
  key: 0,
  class: "item-name leading-5 text-sm text-lightgrey"
}
const _hoisted_8 = {
  key: 0,
  class: "fixed shadow z-50 bg-white w-40 px-2 py-1 min-h-30 flex flex-col justify-center"
}
const _hoisted_9 = { class: "flex flex-row items-center cursor-pointer" }
const _hoisted_10 = { class: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_SessionPopup = _resolveComponent("SessionPopup")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_NavBar),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SessionPopup)
      ]),
      _createElementVNode("div", {
        class: "flex",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeApps()))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass({ 'w-40': _ctx.isTogglingData, 'w-10': !_ctx.isTogglingData })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["fixed bg-primary sidenav flex flex-col justify-between h-full z-50", { 'w-40': _ctx.isTogglingData, 'w-10': !_ctx.isTogglingData }])
          }, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('audit', 'audit'))),
                class: _normalizeClass(["cursor-pointer hover:bg-white svg-icon pl-2.5", _ctx.selectedOptionName === 'audit' ? 'bg-white text-black font-bold a svg-icon123' : 'text-lightgrey font-normal'])
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", _hoisted_3, [
                    _cache[6] || (_cache[6] = _createStaticVNode("<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1ae8f814><g id=\"Audit\" data-v-1ae8f814><g id=\"Group\" data-v-1ae8f814><path id=\"Vector\" d=\"M12.3359 1.14453V4.44563H15.637L12.3359 1.14453Z\" fill=\"#E9E9E9\" data-v-1ae8f814></path><path id=\"Vector_2\" d=\"M12.0898 4.9375C11.9538 4.9375 11.8438 4.8275 11.8438 4.69141V1H2.98438C2.44026 1 2 1.44026 2 1.98438V15.7656C2 16.3097 2.44026 16.75 2.98438 16.75H14.7969C15.341 16.75 15.7812 16.3097 15.7812 15.7656V4.9375H12.0898ZM4.70703 5.42969H8.64453C8.78062 5.42969 8.89062 5.53969 8.89062 5.67578C8.89062 5.81187 8.78062 5.92188 8.64453 5.92188H4.70703C4.57094 5.92188 4.46094 5.81187 4.46094 5.67578C4.46094 5.53969 4.57094 5.42969 4.70703 5.42969ZM13.0742 13.5508H4.70703C4.57094 13.5508 4.46094 13.4408 4.46094 13.3047C4.46094 13.1686 4.57094 13.0586 4.70703 13.0586H13.0742C13.2103 13.0586 13.3203 13.1686 13.3203 13.3047C13.3203 13.4408 13.2103 13.5508 13.0742 13.5508ZM13.0742 12.0742H4.70703C4.57094 12.0742 4.46094 11.9642 4.46094 11.8281C4.46094 11.692 4.57094 11.582 4.70703 11.582H13.0742C13.2103 11.582 13.3203 11.692 13.3203 11.8281C13.3203 11.9642 13.2103 12.0742 13.0742 12.0742ZM13.0742 10.5977H4.70703C4.57094 10.5977 4.46094 10.4877 4.46094 10.3516C4.46094 10.2155 4.57094 10.1055 4.70703 10.1055H13.0742C13.2103 10.1055 13.3203 10.2155 13.3203 10.3516C13.3203 10.4877 13.2103 10.5977 13.0742 10.5977ZM13.0742 9.12109H4.70703C4.57094 9.12109 4.46094 9.01109 4.46094 8.875C4.46094 8.73891 4.57094 8.62891 4.70703 8.62891H13.0742C13.2103 8.62891 13.3203 8.73891 13.3203 8.875C13.3203 9.01109 13.2103 9.12109 13.0742 9.12109ZM13.0742 7.64453H4.70703C4.57094 7.64453 4.46094 7.53453 4.46094 7.39844C4.46094 7.26235 4.57094 7.15234 4.70703 7.15234H13.0742C13.2103 7.15234 13.3203 7.26235 13.3203 7.39844C13.3203 7.53453 13.2103 7.64453 13.0742 7.64453Z\" fill=\"#E9E9E9\" data-v-1ae8f814></path></g></g></svg>", 1)),
                    (_ctx.isTogglingData)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["item-name leading-5 text-sm pl-2", _ctx.selectedOptionName == 'audit' ? 'text-black font-bold' : 'text-listIconColor font-normal'])
                        }, "Audit", 2))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "mb-4" }, null, -1)),
                (_ctx.isSidebarToggle)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_0,
                      class: "h-8 ml-32 icon leftarrow absolute cursor-pointer",
                      alt: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleSideMenuBar()))
                    }))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _imports_1,
                      class: "h-8 icon ml-2 rightarrow absolute cursor-pointer",
                      alt: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSideMenuBar()))
                    }))
              ]),
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("a", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.triggerNavToAdminSettings())),
                  class: _normalizeClass(["flex navchild items-center", { 'pl-1 py-1': _ctx.isSidebarToggle, 'pl-2.5 py-1': !_ctx.isSidebarToggle }])
                }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: _normalizeClass(["icon", { 'px-1.5': _ctx.isSidebarToggle, '': !_ctx.isSidebarToggle }])
                  }, null, 2),
                  (_ctx.isSidebarToggle)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Settings"))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            (_ctx.appsVisible)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: "flex flex-row w-2/4 items-center cursor-pointer",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.triggerNavigation()))
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("img", {
                        src: _imports_3,
                        alt: "",
                        class: "icn h-8 w-8"
                      }, null, -1),
                      _createElementVNode("div", { class: "nav-item-label-container ml-4" }, [
                        _createElementVNode("div", { class: "text-sm font-semibold" }, "Training"),
                        _createElementVNode("div", { class: "active-border" })
                      ], -1)
                    ]))])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["content flex-1 w-full h-screen overflow-y-scroll", { toggledstate: _ctx.isTogglingData }])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _createVNode(_component_Footer)
        ], 2)
      ])
    ])
  ]))
}